var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "label-width": "140px",
          selection: _vm.selection,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("settingAuthorize.header.name"),
                          prop: "logisticsCompanyName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.logisticsCompanyName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "logisticsCompanyName",
                                $$v
                              )
                            },
                            expression: "queryParams.logisticsCompanyName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("settingAuthorize.header.business"),
                          prop: "logisticsBusinessName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.logisticsBusinessName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "logisticsBusinessName",
                                $$v
                              )
                            },
                            expression: "queryParams.logisticsBusinessName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("settingAuthorize.header.type"),
                          prop: "interfaceType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: { "lov-code": "STHI.INTERFACE_TYPE" },
                          model: {
                            value: _vm.queryParams.interfaceType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "interfaceType", $$v)
                            },
                            expression: "queryParams.interfaceType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("settingAuthorize.header.channel"),
                          prop: "channelTypeCode",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: { "lov-code": "SCHL.CHANNEL_TYPE" },
                          model: {
                            value: _vm.queryParams.channelTypeCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "channelTypeCode", $$v)
                            },
                            expression: "queryParams.channelTypeCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("settingAuthorize.authorized")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    false
                                      ? void 0
                                      : [
                                          "autoGetLogisticsNo",
                                          "defaultFlag",
                                        ].includes(col.prop)
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: row[col.prop]
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_TRUE.bjGet(
                                                    row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "warehouseList"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                row[col.prop] &&
                                                  row[col.prop]
                                                    .map(function (e) {
                                                      return e.warehouseName
                                                    })
                                                    .join()
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "channelList"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                row[col.prop] &&
                                                  row[col.prop]
                                                    .map(function (e) {
                                                      return e.channelTypeCodeMeaning
                                                    })
                                                    .join()
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop ===
                                        "printCloudStandardTemplate"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(row[col.prop].name) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "address"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                row.province +
                                                  row.city +
                                                  row.district +
                                                  row[col.prop]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                row[col.prop],
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("DataForm", { ref: "DataForm", on: { reFresh: _vm.reFresh } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }